<template>
  <div>
    <b-row style="color:red;font-size:15pt;">
      이메뉴에 테스트필요 api 항목 이름 이메일 settingId 등 확인 필요,
      검색 필요
    </b-row>
    <b-row>
      <b-colxx xxs="12">
        <h1>{{ $t('menu.user-list') }}</h1>
        <piaf-breadcrumb/>
        <div class="separator mb-5"/>
      </b-colxx>
    </b-row>

    <b-row class="mb-5">
      <b-colxx xxs="12">
        <b-card class="mb-4">
          <b-row>
            <b-colxx xxs="12" md="5" lg="4">
              <v-select :options="searchOptions" v-model="searchKind" :reduce="item => item.value" label="label" ></v-select>
            </b-colxx>
            <b-colxx xxs="10" md="5" lg="4">
              <b-input-group class="mb-3">
                <b-input :placeholder="$t('menu.search')" v-model="searchKeyword" @keyup.enter="onSearch"/>
                <b-button v-show="!searchFlag" @click="onSearch" variant="outline-primary default" size="sm">
                  {{$t('button.search')}}
                </b-button>
                <b-button v-show="searchFlag" @click="searchCancel" variant="outline-primary" size="sm">
                  {{$t('button.search-cancel')}}
                </b-button>
              </b-input-group>
            </b-colxx>
            <b-colxx xxs="2" md="2" lg="4">
              <div class="float-md-right pt-1">
                <b-dropdown id="ddown2" right :text="`${perPage}`" variant="outline-primary" class="d-inline-block"
                            size="md">
                  <b-dropdown-item v-for="(size,index) in pageSizes" :key="index" @click="changePageSize(size)">{{ size
                    }}
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </b-colxx>
          </b-row>

          <template v-if="isLoad" >
          <b-table
            head-variant="light"
            ref="general-table"
            class="vuetable"
            selectedVariant="primary"
            :current-page="currentPage"
            :per-page="perPage"
            :items="items"
            :fields="fields"
            primary-key="settingId"
            responsive
            show-empty
          >
<!--            <template v-slot:head(selected)="row">-->
<!--              <b-form-checkbox v-model="selectAll"></b-form-checkbox>-->
<!--            </template>-->

            <template v-slot:cell(username)="row">
              <router-link :to="`user-detail/${row.item.username}`" class="cls_click">
                {{row.item.username}}
              </router-link>
            </template>

            <template v-slot:empty>
              <h4 style="text-align:center">조회된 내용이 없습니다.</h4>
            </template>
<!--            <template v-slot:cell(selected)="row">-->
<!--              <b-form-checkbox v-model="row.item.selected" @change="changedItemCheck(row)"></b-form-checkbox>-->
<!--            </template>-->

          </b-table>

          <b-pagination v-if="lastPage > 1"
            size="sm"
            align="center"
            :total-rows="total"
            :per-page="perPage"
            v-model="currentPage"
          >
            <template v-slot:next-text>
              <i class="simple-icon-arrow-right"/>
            </template>
            <template v-slot:prev-text>
              <i class="simple-icon-arrow-left"/>
            </template>
            <template v-slot:first-text>
              <i class="simple-icon-control-start"/>
            </template>
            <template v-slot:last-text>
              <i class="simple-icon-control-end"/>
            </template>
          </b-pagination>

          <div style="text-align: right">
            <b-button class="mb-1" @click="register" variant="primary">등록</b-button>
          </div>
          </template>
          <template v-else>
            <div class="loading"></div>
          </template>

        </b-card>
      </b-colxx>
    </b-row>


  </div>
</template>
<script>
  import api from '../../constants/api'
  import vSelect from 'vue-select'
  import 'vue-select/dist/vue-select.css'
  import '../../assets/css/custom/common.css'
  import { alignTableCenter } from '../../utils'

  import {
    mapGetters,
    mapActions
  } from "vuex";

  import {
    validationMixin
  } from "vuelidate";

  const {
    required,
    maxLength,
    minLength,
    email
  } = require("vuelidate/lib/validators");

  export default {
    components: {
      'v-select': vSelect
    },
    data() {
      return {
        isLoad : false ,
        searchKind: 'ALL' ,
        searchOptions: [
          {label: '전체', value: 'ALL'},
          {label: '아이디', value: 'username'},
          {label: '이름', value: 'fullName'},
          {label: '전화번호', value: 'phone'},
        ],
        selectAll: false,
        items: [
          {settingId: 1, username: 'sally', fullName: '고솔비', email : "sally@tablenjoy.com" ,regDate: this.$moment(new Date()).format('L')},
          {settingId: 2, username: 'hank', fullName: '이행철', email: "hank@tablenjoy.com" , regDate: this.$moment(new Date()).format('L')},
          {settingId: 3, username: 'ella', fullName: '최은서', email : "ella@tablenjoy.com" , regDate: this.$moment(new Date()).format('L')},
          {settingId: 4, username: 'jason', fullName: '류재성', email : "jason@tablenjoy.com" , regDate: this.$moment(new Date()).format('L')},
        ],
        fields: [
          {key: 'settingId', label: '번호' , ...alignTableCenter},
          {key: 'fullName', label: '이름', ...alignTableCenter},
          {key: 'username', label: '아이디' , ...alignTableCenter},
          {key: 'email', label: '이메일', ...alignTableCenter},
          {key: 'regDate', label: '등록일'},
        ],
        searchFlag: false,
        selectedMemberId: null,
        pageSizes: [10, 20, 30],
        currentPage: 1,
        perPage: 10,
        searchKeyword: '',
        total: 1,
        lastPage: 1
      }
    },
    mixins: [validationMixin],
    validations: {},
    computed: {
      ...mapGetters(['currentUser', 'siteName'])
    },
    mounted() {
      this.searchData()
    },
    watch: {
      selectAll(chk) {
        this.items.forEach(v => {
          v.selected = chk
        })
      },
    },
    methods: {
      searchData() {
        this.isLoad = false
        const reqURL = api.changeAPI(this.siteName, api.basicURL + api.auth.login)
        const params = {

        }

        this.$http.get(reqURL, {
          params: params,
          headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
        }).then(res => {
            if ( res.data.code === "OK" ) {
              this.items = res.data.data
              this.lastPage = res.data.data.totalPages
              this.total = res.data.data.totalElements
              this.perPage = res.data.data.size
            } else {
                throw 400
            }
        }).catch(err => {
          alert(err.response.data.message);
        })

        this.isLoad = true
      },
      register() {

      },
      onSearch() {
        if( this.searchKeyword === "" ){
          alert('검색어를 입력하세요');
          return false
        }
        // this.searchFlag = true;
        this.searchData();
      },
      searchCancel() {
        this.searchFlag = false;
        this.searchKeyword = '';
        this.searchData();
      },
      changePageSize(perPage) {
        this.perPage = perPage
      },
      changedItemCheck(row) {
        console.log(row)
      }
    }
  }
</script>
